// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "javascripts/" + chunkId + "." + "2d128b0dee028150cd60" + ".js";
};